<section data-test="KSvBzRv9" class="mb-0 no-print">
  <h2 data-test="0HjloGjo">{{ label }}</h2>
  <div data-test="UzBN76BR" class="file-upload form-group" *ngIf="!readOnly">
    <label data-test="_zy7uxQA" class="input-file input-file_wide">
      <input data-test="uj6-lkwA" id="input-1" type="file" (input)="uploadFile($event)" />
      <div
        data-test="ZkYj1S3D"
        mdDragDrop
        #dragDropDirective="mdDragDrop"
        pattern="."
        [canRead]="true"
        (dropHandler)="uploadFile($any($event))"
        class="input-file__inner"
      >
        <span data-test="kl-IyHht" class="input-file__icon">
          <svg data-test="aco_GK4E" class="icon__icon-upload" width="34px" height="30px">
            <use xlink:href="#icon-upload"></use>
          </svg>
        </span>
        <div data-test="QpyhhySw" class="input-file__text">
          Drop files here to upload or
          <span data-test="KdCh3spY" class="link">choose file</span>
        </div>
      </div>
    </label>
  </div>
  <table data-test="uSWWMRMA" class="items-table items-table_light mb-0">
    <tbody data-test="sOcnhMgV">
      <tr data-test="XSzAY0hf" *ngFor="let file of files">
        <td data-test="dpJH2esA">
          <div data-test="KibmZoR5" class="items-table__img-block">
            <div
              data-test="1OVrPfvk"
              class="img-square img-square_transparent"
              *ngIf="getUploadedFile(file) as file"
            >
              <svg
                data-test="FAOfDKC0"
                class="icon__icon-file-word"
                width="22px"
                height="26px"
              >
                <use [attr.xlink:href]="'#icon-file-' + getIcon(file.file)"></use>
              </svg>
            </div>
            <div data-test="_y_avtNY" class="items-table__img-block-title">
              <div data-test="XsPYhNhI">
                <b data-test="dJmvVZvo">{{ file.name }}</b>
                <b data-test="BSwZGMRC" class="text-light">
                  ({{ file.size | fileSize }})
                </b>
              </div>
              <span
                data-test="Nm5lSsBm"
                class="text-light font-weight-medium"
                *ngIf="getUploadedFile(file) as file"
              >
                Uploaded: {{ file.createdAt | formatDate: 'dd MMM yyyy' }} at
                {{ file.createdAt | formatDate: 'h:mm' }}
              </span>
            </div>
          </div>
        </td>
        <td data-test="rt4GdrPx" class="text-right">
          <a
            data-test="4bGOiA4y"
            [href]="imagesPath + getUploadedFile(file)?.file"
            [download]="file.name"
            target="_blank"
            class="icon icon_sm icon_13 mr-1"
          >
            <svg
              data-test="AbW-ykEH"
              class="icon__icon-download"
              width="12.29px"
              height="12px"
            >
              <use xlink:href="#icon-download"></use>
            </svg>
          </a>
          <button
            data-test="klaCQhSO"
            *ngIf="!readOnly"
            (click)="removeFile(file)"
            type="button"
            class="icon icon_sm icon_13 text-red"
          >
            <svg data-test="b-kHseu6" class="icon__icon-trash" width="10px" height="11px">
              <use xlink:href="#icon-trash"></use>
            </svg>
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</section>
